import React from "react";
import { motion } from "framer-motion";
import { Leaf } from "lucide-react";
import { Spaced } from "@/components/site/Hero";
import { useT } from "@/i18n/LanguageContext";

export default function Sustainability() {
  const { t } = useT();
  return (
    <section
      id="sustainability"
      className="relative py-32 lg:py-40 overflow-hidden bg-gradient-to-b from-white via-[#EAFAFB] to-white"
    >
      <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full blur-3xl opacity-30"
           style={{ background: "radial-gradient(circle, #25bfcf 0%, transparent 60%)" }} />
      <img
        aria-hidden
        src="/hupla-emblem.svg"
        alt=""
        className="pointer-events-none select-none absolute -left-40 top-1/2 -translate-y-1/2 w-[720px] max-w-none opacity-[0.06]"
      />

      <div className="relative mx-auto max-w-[1200px] px-6 lg:px-10 text-center">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#25bfcf] mb-10"
        >
          <Leaf className="w-7 h-7 text-white" />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-black text-[#001F39] text-[clamp(2rem,5vw,4rem)]"
        >
          <Spaced text={t("sustainability.title")} />
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-10 max-w-3xl mx-auto text-xl md:text-2xl leading-relaxed font-editorial italic text-[#001F39]"
        >
          &ldquo;{t("sustainability.quote")}&rdquo;
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.35 }}
          className="mt-10 max-w-3xl mx-auto text-lg text-neutral-600 leading-relaxed"
        >
          {t("sustainability.body")}
        </motion.p>

        {/* Decorative wave circles */}
        <div className="mt-20 flex justify-center items-center gap-4">
          {[0, 1, 2, 3, 4].map((i) => (
            <img
              key={i}
              src="/world/wave-circle.svg"
              alt=""
              aria-hidden
              className="h-10 md:h-12 w-auto opacity-70"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
